import { useRef, useState, useEffect } from "react";

const hasIntersectionObserver = typeof IntersectionObserver !== "undefined";

const useIsInView = ({ onVisible, onInvisible }) => {
  const [node, setNode] = useState();
  const cbRef = useRef({ onVisible, onInvisible });
  useEffect(() => {
    cbRef.current = { onVisible, onInvisible };
  });

  useEffect(() => {
    if (!node) return undefined;
    if (!hasIntersectionObserver) return cbRef.current.onVisible();

    const handleIntersect = ([event]) => {
      if (event.isIntersecting) {
        cbRef.current.onVisible();
      } else {
        cbRef.current.onInvisible();
      }
    };

    const options = { root: null, threshold: 1 };
    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [node]);

  return setNode;
};

export default useIsInView;
